module.exports = __webpack_public_path__ + "img/startbg.4accd29.png";